<template>
    <div>
        <div v-for="sponsorItem in articleItem[0]" :key="sponsorItem.ID" v-if="sponsorItem.ebene" class="">
            <div class="-mb-3">
                <span v-if="sponsorItem.ebene == 1">
                    <the-title parentcolor="orange">
                        <slot slot="de">Schirmherren</slot>
                        <slot slot="en">Patrons</slot>
                    </the-title>
                </span>

                <span v-if="sponsorItem.ebene == 2">
                    <the-title parentcolor="orange">
                        <slot slot="de">Hauptsponsoren</slot>
                        <slot slot="en">Main Sponsors</slot>
                    </the-title>
                </span>
                <span v-if="sponsorItem.ebene == 3">
                    <the-title parentcolor="orange">
                        <slot slot="de">Premium-Sponsoren</slot>
                        <slot slot="en">Sponsors</slot>
                    </the-title>

                </span>
                <span v-if="sponsorItem.ebene == 4">
                    <the-title parentcolor="orange">
                        <slot slot="de">Top-Partner</slot>
                        <slot slot="en">Partners</slot>
                    </the-title>
                </span>
            </div>
            <sponsorebene :sponsor="sponsorItem"></sponsorebene>
            <div class="sepWrap">
                <seperator />
            </div>
        </div>
    </div>
</template>


<script>

    import sponsorebene from './sponsorebene'
    import seperator from '../seperator'
    import TheTitle from "../TheTitle";


    export default {
        name: 'Sponsors',
        components: {
            sponsorebene,
            seperator,
            TheTitle
        },
        data() {
            return {
                articleItem: Object
            }
        },

        created: function(){
            const baseURI = 'https://api.pgsi2020.de/api/file/sponsors.json'
            this.$http.get(baseURI)
                .then((result) => {
                    this.articleItem = result.data
                })
        }
    }
</script>

<style>
    .sepWrap{
        vertical-align: top;
        margin: 0;
        height: 0;
        line-height: 1px;
    }
</style>
